<template>
  <div class="flex flex-col min-h-screen bg-surface-100 items-center">
    <LayoutHeader class="sticky top-0 left-0 right-0 z-[1000] w-full" />
    <slot name="noLayout" />
    <div class="flex flex-col flex-grow w-full items-center justify-start">
      <LayoutContainer>
        <div class="flex flex-col py-8 gap-12 md:py-12">
          <slot />
        </div>
      </LayoutContainer>
    </div>
    <LayoutFooter class="w-full" />
  </div>
</template>
